var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDistributeVerticalSpacing = function SvgDistributeVerticalSpacing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.667,
    height: 5.333,
    fill: "currentColor",
    rx: 0.667,
    transform: "matrix(0 1 1 0 5.333 6.667)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.74 4H3.26c-.328 0-.593-.298-.593-.667 0-.368.265-.666.592-.666h9.482c.327 0 .592.298.592.666S13.068 4 12.741 4M12.74 13.333H3.26c-.328 0-.593-.298-.593-.666S2.932 12 3.259 12h9.482c.327 0 .592.299.592.667s-.265.666-.592.666"
  })));
};
export default SvgDistributeVerticalSpacing;